<loading-overlay *ngIf="loading$ | async" [message]="loadingMessage"></loading-overlay>
<table data-automation-id="individual-table"
       class="table table-bordered job-pharma-animals-individual">
    <thead>
        <tr class="detail-grid-header">

            <!-- Drag Handle -->
            <th *ngIf="!readonly" class="icon-cell"></th>

            <!-- Select -->
            <th *ngIf="!readonly" class="icon-cell">
                <input type="checkbox"
                       name="selectAll"
                       [(ngModel)]="jobPharmaAnimalsIndividualTableService.allRowsSelected"
                       (ngModelChange)="jobPharmaAnimalsIndividualTableService.allSelectedChanged(animalJobMaterials, job)"
                       title="Select/Clear all" />
            </th>

            <!-- Paste/Remove -->
            <th *ngIf="!readonly">
                <a class="detail-grid-button"
                   (click)="onPaste()">
                    <i data-automation-id="paste-animals-button"
                       class="fa fa-paste"
                       title="Paste Animals">
                    </i>
                </a>
            </th>

            <!-- Name -->
            <th *ngIf="visibleColumns.name"
                droppable
                [dropDisabled]="readonly"
                (drop)="onDrop()"
                [attr.title]="readonly ? '' : 'Drop animals here'">
                <div class="d-md-inline-block min-width60">
                    <a *ngIf="!readonly" 
                       (click)="sortColumn('Material.Animal.AnimalNameSortable', $event)"
                       class="header-sort-link"
                       title="Sort by Name">
                        Name {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.AnimalNameSortable'] : '' }}
                        <i class="fa"
                           [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.AnimalNameSortable'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.AnimalNameSortable'] : !tableSort.reverse
                                    }"
                           style="font-size: 10px !important;"
                           *ngIf="tableSort.propertyPath === 'Material.Animal.AnimalNameSortable' || tableSort.nested && tableSort.properties.includes('Material.Animal.AnimalNameSortable')"></i>
                    </a>
                    <span *ngIf="readonly">Name</span>
                </div>
                <div class="d-md-inline-block">
                    <ng-container *ngIf="!readonly">
                        <bulk-edit-header [headerText]="'Rename'"
                                          (updateClicked)="onBulkAnimalNameUpdated(bulkNamePrefix, bulkNameSuffix, bulkNameCounter)"
                                          [disabled]="!bulkNameCounter">
                            <div modal-content class="bulk-name d-flex text-body">
                                <div class="form-group mr-1 mb-0">
                                    <label>Prefix</label>
                                    <input type="text"
                                           class="form-control"
                                           [(ngModel)]="bulkNamePrefix"
                                           name="bulkNamePrefix" />
                                </div>
                                <div class="form-group mr-1 mb-0">
                                    <label>Counter</label>
                                    <input type="number"
                                           class="form-control"
                                           [(ngModel)]="bulkNameCounter"
                                           [required]="true"
                                           name="bulkNameCounter" />
                                </div>
                                <div class="form-group mb-0">
                                    <label>Suffix</label>
                                    <input type="text"
                                           class="form-control"
                                           [(ngModel)]="bulkNameSuffix"
                                           name="bulkNameSuffix" />
                                </div>
                            </div>
                        </bulk-edit-header>
                        <span class="float-right">
                        </span>
                    </ng-container>
                </div>
            </th>

            <!-- Nickname on Study -->
            <th *ngIf="visibleColumns.nickname">
                <div class="d-md-inline-block min-width130">
                    <a (click)="sortColumn('NicknameSortable', $event)"
                       class="header-sort-link"
                       title="Sort by Nickname">
                        Nickname on {{'Job' | translate}} {{ tableSort.nested ? tableSort.nestedIndex['NicknameSortable'] : '' }}
                        <i class="fa"
                           [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['NicknameSortable'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['NicknameSortable'] : !tableSort.reverse
                                    }"
                           style="font-size: 10px !important;"
                           *ngIf="tableSort.propertyPath === 'NicknameSortable' || tableSort.nested && tableSort.properties.includes('NicknameSortable')"></i>
                    </a>
                </div>
                <div class="d-md-inline-block">
                    <ng-container *ngIf="!readonly">
                        <bulk-edit-header [headerText]="'Rename'"
                                          [updateButtonText]="nicknameUpdateButtonText"
                                          (updateClicked)="onBulkAnimalNicknameUpdated(bulkNicknamePrefix, bulkNicknameSuffix, bulkNicknameCounter)"
                                          [disabled]="!bulkNicknameCounter">
                            <div modal-content class="bulk-name d-flex text-body">
                                <div class="form-group mr-1 mb-0">
                                    <label>Prefix</label>
                                    <input type="text"
                                           class="form-control"
                                           [(ngModel)]="bulkNicknamePrefix"
                                           name="bulkNicknamePrefix" />
                                </div>
                                <div class="form-group mr-1 mb-0">
                                    <label>Counter</label>
                                    <input type="number"
                                           class="form-control"
                                           [(ngModel)]="bulkNicknameCounter"
                                           [required]="true"
                                           name="bulkNicknameCounter" />
                                </div>
                                <div class="form-group mb-0">
                                    <label>Suffix</label>
                                    <input type="text"
                                           class="form-control"
                                           [(ngModel)]="bulkNicknameSuffix"
                                           name="bulkNicknameSuffix" />
                                </div>
                            </div>
                        </bulk-edit-header>
                        <span class="float-right">
                        </span>
                    </ng-container>
                </div>
            </th>

            <!-- Past Nicknames on Study -->
            <th *ngIf="visibleColumns.pastNicknames">
                <a (click)="sortColumn('JobMaterialPastNicknames.PastNicknamesSortable', $event)"
                   class="header-sort-link"
                   title="Sort by Past Nicknames on {{'Job' | translate}}">
                    Past Nicknames on {{'Job' | translate}} {{ tableSort.nested ? tableSort.nestedIndex['JobMaterialPastNicknames.PastNicknamesSortable'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['JobMaterialPastNicknames.PastNicknamesSortable'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['JobMaterialPastNicknames.PastNicknamesSortable'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'JobMaterialPastNicknames.PastNicknamesSortable' || tableSort.nested && tableSort.properties.includes('JobMaterialPastNicknames.PastNicknamesSortable')"></i>
                </a>
            </th>

            <!--Line-->
            <th *ngIf="visibleColumns.line">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Line.LineName', $event)"
                   class="header-sort-link"
                   title="Sort by {{'Line' | translate}}">
                    {{'Line' | translate}} {{ tableSort.nested ? tableSort.nestedIndex['Material.Line.LineName'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Line.LineName'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Line.LineName'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Line.LineName' || tableSort.nested && tableSort.properties.includes('Material.Line.LineName')"></i>
                </a>
                <span *ngIf="readonly">{{'Line' | translate}}</span>
            </th>
            <th *ngIf="visibleColumns.genotype">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.GenotypesSortable', $event)"
                   class="header-sort-link"
                   title="Sort by Genotype">
                    Genotype {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.GenotypesSortable'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.GenotypesSortable'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.GenotypesSortable'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.GenotypesSortable' || tableSort.nested && tableSort.properties.includes('Material.Animal.GenotypesSortable')"></i>
                </a>
                <span *ngIf="readonly">Genotype</span>
            </th>
            <th *ngIf="visibleColumns.sex">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.cv_Sex.Sex', $event)"
                   class="header-sort-link"
                   title="Sort by Sex">
                    Sex {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.cv_Sex.Sex'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.cv_Sex.Sex'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.cv_Sex.Sex'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.cv_Sex.Sex' || tableSort.nested && tableSort.properties.includes('Material.Animal.cv_Sex.Sex')"></i>
                </a>
                <span *ngIf="readonly">Sex</span>
            </th>
            <th *ngIf="visibleColumns.birthDate">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.DateBorn', $event)"
                   class="header-sort-link"
                   title="Sort by Birth Date">
                    Birth Date {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.DateBorn'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.DateBorn'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.DateBorn'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.DateBorn' || tableSort.nested && tableSort.properties.includes('Material.Animal.DateBorn')"></i>
                </a>
                <span *ngIf="readonly">Birth Date</span>
            </th>
            <th *ngIf="visibleColumns.status">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.cv_AnimalStatus.AnimalStatus', $event)"
                   class="header-sort-link"
                   title="Sort by Name">
                    Status {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.cv_AnimalStatus.AnimalStatus'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.cv_AnimalStatus.AnimalStatus'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.cv_AnimalStatus.AnimalStatus'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.cv_AnimalStatus.AnimalStatus' || tableSort.nested && tableSort.properties.includes('Material.Animal.cv_AnimalStatus.AnimalStatus')"></i>
                </a>
                <span *ngIf="readonly">Status</span>
            </th>
            <th *ngIf="visibleColumns.heldFor && isGLP">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.HeldFor', $event)"
                   class="header-sort-link"
                   title="Sort by Held For">
                    Held For {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.HeldFor'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.HeldFor'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.HeldFor'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.HeldFor' || tableSort.nested && tableSort.properties.includes('Material.Animal.HeldFor')"></i>
                </a>
                <span *ngIf="readonly">Held For</span>
            </th>
            <th *ngIf="visibleColumns.housing">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.MaterialTopMaterialPool.HousingID', $event)"
                   class="header-sort-link"
                   title="Sort by Housing ID">
                    Housing ID {{ tableSort.nested ? tableSort.nestedIndex['Material.MaterialTopMaterialPool.HousingID'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                         'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.MaterialTopMaterialPool.HousingID'] : tableSort.reverse,
                         'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.MaterialTopMaterialPool.HousingID'] : !tableSort.reverse
                       }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.MaterialTopMaterialPool.HousingID' || tableSort.nested && tableSort.properties.includes('Material.MaterialTopMaterialPool.HousingID')">
                    </i>
                </a>
                <span *ngIf="readonly">Housing ID</span>
            </th>
            <th *ngIf="visibleColumns.microchipIdentifier">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.MicrochipIdentifier', $event)"
                   class="header-sort-link"
                   title="Sort by Microchip ID">
                    Microchip ID {{ tableSort.nested ? tableSort.nestedIndex['Material.MicrochipIdentifier'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.MicrochipIdentifier'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.MicrochipIdentifier'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.MicrochipIdentifier' || tableSort.nested && tableSort.properties.includes('Material.MicrochipIdentifier')"></i>
                </a>
                <span *ngIf="readonly">Microchip ID</span>
            </th>
            <th *ngIf="visibleColumns.alternatePhysicalID && isGLP">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.AlternatePhysicalID', $event)"
                   class="header-sort-link"
                   title="Sort by Alternate Physical ID">
                    Alternate Physical ID {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.AlternatePhysicalID'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.AlternatePhysicalID'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.AlternatePhysicalID'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.AlternatePhysicalID' || tableSort.nested && tableSort.properties.includes('Material.Animal.AlternatePhysicalID')"></i>
                </a>
                <span *ngIf="readonly">Alternate Physical ID</span>
            </th>
            <th *ngIf="visibleColumns.externalIdentifier">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.ExternalIdentifier', $event)"
                   class="header-sort-link"
                   title="Sort by External ID">
                    External ID {{ tableSort.nested ? tableSort.nestedIndex['Material.ExternalIdentifier'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.ExternalIdentifier'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.ExternalIdentifier'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.ExternalIdentifier' || tableSort.nested && tableSort.properties.includes('Material.ExternalIdentifier')"></i>
                </a>
                <span *ngIf="readonly">External ID</span>
            </th>
            <th *ngIf="visibleColumns.CITESNumber && isGLP">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.CITESNumber', $event)"
                   class="header-sort-link"
                   title="Sort by CITES Number">
                    CITES Number {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.CITESNumber'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.CITESNumber'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.CITESNumber'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.CITESNumber' || tableSort.nested && tableSort.properties.includes('Material.Animal.CITESNumber')"></i>
                </a>
                <span *ngIf="readonly">CITES Number</span>
            </th>
            <th *ngIf="visibleColumns.classification && isGLP">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.cv_Classification.Classification', $event)"
                   class="header-sort-link"
                   title="Sort by External ID">
                    Classification {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.cv_Classification.Classification'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.cv_Classification.Classification'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.cv_Classification.Classification'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.cv_Classification.Classification' || tableSort.nested && tableSort.properties.includes('Material.Animal.cv_Classification.Classification')"></i>
                </a>
                <span *ngIf="readonly">Classification</span>
            </th>
            <th *ngIf="visibleColumns.ageDays">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.DateBorn', $event)"
                   class="header-sort-link"
                   title="Sort by Age">
                    Age (Days) {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.DateBorn'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.DateBorn'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.DateBorn'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.DateBorn' || tableSort.nested && tableSort.properties.includes('Material.Animal.DateBorn')"></i>
                </a>
                <span *ngIf="readonly">Age (Days)</span>
            </th>
            <th *ngIf="visibleColumns.ageWeeks">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.DateBorn', $event)"
                   class="header-sort-link"
                   title="Sort by Age">
                    Age (Weeks) {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.DateBorn'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.DateBorn'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.DateBorn'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.DateBorn' || tableSort.nested && tableSort.properties.includes('Material.Animal.DateBorn')"></i>
                </a>
                <span *ngIf="readonly">Age (Weeks)</span>
            </th>
            <th *ngIf="visibleColumns.ageMonths">
                <a *ngIf="!readonly"
                   (click)="sortColumn('Material.Animal.DateBorn', $event)"
                   class="header-sort-link"
                   title="Sort by Age">
                    Age (Months) {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.DateBorn'] : '' }}
                    <i class="fa"
                       [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.DateBorn'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.DateBorn'] : !tableSort.reverse
                                    }"
                       style="font-size: 10px !important;"
                       *ngIf="tableSort.propertyPath === 'Material.Animal.DateBorn' || tableSort.nested && tableSort.properties.includes('Material.Animal.DateBorn')"></i>
                </a>
                <span *ngIf="readonly">Age (Months)</span>
            </th>
            <th *ngIf="visibleColumns.cohort">
                <div class="text-nowrap dropdown-wrapper">
                    <div class="d-md-inline-block min-width130" *ngIf="primaryCohortsExpanded">
                        <a *ngIf="!readonly"
                           (click)="sortColumn('PrimaryCohortsSortable', $event)"
                           class="header-sort-link"
                           title="Sort by Primary Cohort">
                            Primary Cohorts {{ tableSort.nested ? tableSort.nestedIndex['PrimaryCohortsSortable'] : '' }}
                            <i class="fa"
                               [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['PrimaryCohortsSortable'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['PrimaryCohortsSortable'] : !tableSort.reverse
                                    }"
                               style="font-size: 10px !important;"
                               *ngIf="tableSort.propertyPath === 'PrimaryCohortsSortable'"></i>
                        </a>
                        <span *ngIf="readonly">Primary Cohorts</span>
                    </div>
                    <div class="d-md-inline-block min-width100" *ngIf="!primaryCohortsExpanded">
                        <a *ngIf="!readonly"
                           (click)="sortColumn('Material.Animal.CohortsSortable', $event)"
                           class="header-sort-link"
                           title="Sort by Cohort">
                            All Cohort {{ tableSort.nested ? tableSort.nestedIndex['Material.Animal.CohortsSortable'] : '' }}
                            <i class="fa"
                               [ngClass]="{
                                      'fa-arrow-down': tableSort.nested ? tableSort.nestedReverse['Material.Animal.CohortsSortable'] : tableSort.reverse,
                                      'fa-arrow-up': tableSort.nested ? !tableSort.nestedReverse['Material.Animal.CohortsSortable'] : !tableSort.reverse
                                    }"
                               style="font-size: 10px !important;"
                               *ngIf="tableSort.propertyPath === 'Material.Animal.CohortsSortable' || tableSort.nested && tableSort.properties.includes('Material.Animal.CohortsSortable')"></i>
                        </a>
                        <span *ngIf="readonly">All Cohort</span>
                    </div>
                    <div class="d-md-inline-block">
                        <a class="dropdown-toggle"
                           data-toggle="dropdown"
                           aria-haspopup="true"
                           aria-expanded="false">
                            View
                        </a>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" (click)="viewPrimaryCohorts()">View Primary Cohorts</a>
                            <a class="dropdown-item" (click)="viewAllCohorts()">View All Cohorts</a>
                        </div>
                    </div>
                </div>
            </th>
            <th *ngIf="visibleColumns.sequence">Sequence</th>
        </tr>
    </thead>
    <!-- open -->
    <tbody
           [hidden]="(loading$ | async)"
           [dragula]="dragulaBagName"
           [dragulaModel]="animalJobMaterials"
           >
        <tr *ngFor="let jobMaterial of animalJobMaterials |
                paginate: { itemsPerPage: 50, currentPage: page, id: 'animals-individual-pagination', totalItems: animalCount };"
            [attr.data-key]="jobMaterial?.C_Material_key"
            [ngClass]="{'selected-row': jobMaterial?.isSelected}"
            class="individual-animal-row">
            <ng-container *ngIf="jobMaterial?.Material?.Animal as animal">

                <!-- Drag Handle -->
                <td *ngIf="!readonly"
                    class="icon-cell">
                    <i class="fa fa-sort text-muted"
                       [ngClass]="{
                         'draggable': !jobPharmaAnimalsIndividualTableService.selectedRows.size > 0 || jobMaterial.isSelected,
                         'mt-1': visibleColumns.nickname
                       }"
                       title="Drag to reorder"></i>
                </td>

                <!-- Select -->
                <td *ngIf="!readonly"
                    class="icon-cell">
                    <input type="checkbox"
                           name="select-animals-individual-{{index}}"
                           [(ngModel)]="jobMaterial.isSelected"
                           [class.mt-1]="visibleColumns.nickname"
                           (ngModelChange)="jobPharmaAnimalsIndividualTableService.isSelectedChanged(job, animalJobMaterials, jobMaterial)" />
                </td>

                <!-- Remove -->
                <td class="icon-cell"
                    *ngIf="!readonly">
                    <a (click)="removeAnimalJobMaterial(jobMaterial)" 
                       class="remove-individual-animal">
                        <i class="fa fa-remove remove-item" [class.mt-1]="visibleColumns.nickname" title="Remove Animal"></i>
                    </a>
                </td>

                <!-- Name -->
                <td *ngIf="visibleColumns.name">
                    <div data-drag-type="material"
                         draggable
                         (dragStart)="jobPharmaAnimalsIndividualTableService.dragStart(job)"
                         (dragStop)="jobPharmaAnimalsIndividualTableService.dragStop()"
                         [dragDisabled]="!jobMaterial.isSelected"
                         id="drag-animals-individual-{{animal.C_Material_key}}"
                         class="individual-animal-name"
                         [class.mt-1]="visibleColumns.nickname">
                        {{animal.AnimalName}}
                    </div>
                </td>

                <!-- Nickname on Study -->
                <td *ngIf="visibleColumns.nickname">
                    <input type="text"
                           maxlength="75"
                           class="form-control"
                           #nicknameInputControl="ngModel"
                           [(ngModel)]="jobMaterial.Nickname"
                           (ngModelChange)="onNicknameChange(jobMaterial)"
                           [ngClass]="{'ng-invalid': !jobMaterial.IsNicknameValid}" />
                </td>

                <!-- Past Nicknames on Study -->
                <td *ngIf="visibleColumns.pastNicknames">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{jobMaterial.JobMaterialPastNicknames?.PastNicknames}}
                    </div>
                </td>

                <!-- Line -->
                <td *ngIf="visibleColumns.line">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{jobMaterial.Material.Line?.LineName}}
                    </div>
                </td>

                <!-- Genotype -->
                <td *ngIf="visibleColumns.genotype">
                    <ng-template [ngIf]="animal?.Genotype?.length > 0">
                        <span [class.mt-1]="visibleColumns.nickname">{{ animal?.Genotype | formatGenotypeNames}}</span>
                    </ng-template>
                </td>

                <!-- Sex -->
                <td *ngIf="visibleColumns.sex">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.cv_Sex?.Sex}}
                    </div>
                </td>

                <!-- Birth Date -->
                <td *ngIf="visibleColumns.birthDate">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.DateBorn | formatShortDate}}
                    </div>
                </td>

                <!-- Status -->
                <td *ngIf="visibleColumns.status">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.cv_AnimalStatus?.AnimalStatus}}
                    </div>
                </td>

                <!-- Held For -->
                <td *ngIf="visibleColumns.heldFor && isGLP">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.HeldFor}}
                    </div>
                </td>

                <!-- Housing ID -->
                <td *ngIf="visibleColumns.housing">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{jobMaterial.Material?.MaterialPoolMaterial | currentMaterialHousingID}}
                    </div>
                </td>

                <!-- Microchip ID -->
                <td *ngIf="visibleColumns.microchipIdentifier ">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.Material.MicrochipIdentifier}}
                    </div>
                </td>

                <!-- AlternatePhysical ID -->
                <td *ngIf="visibleColumns.alternatePhysicalID && isGLP">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.AlternatePhysicalID}}
                    </div>
                </td>

                <!-- External ID -->
                <td *ngIf="visibleColumns.externalIdentifier">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.Material.ExternalIdentifier}}
                    </div>
                </td>

                <!-- CITES Number-->
                <td *ngIf="visibleColumns.CITESNumber && isGLP">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.CITESNumber}}
                    </div>
                </td>

                <!-- Classification -->
                <td *ngIf="visibleColumns.classification && isGLP">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.cv_Classification?.Classification}}
                    </div>
                </td>

                <!-- Age (Days) -->
                <td *ngIf="visibleColumns.ageDays">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.DateBorn | animalAgeDays:animal.DateExit | number}}
                    </div>
                </td>

                <!-- Age (Weeks) -->
                <td *ngIf="visibleColumns.ageWeeks">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.DateBorn | animalAgeWeeks:animal.DateExit | number}}
                    </div>
                </td>

                <!-- Age (Months) -->
                <td *ngIf="visibleColumns.ageMonths">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{animal.DateBorn | animalAgeMonths:animal.DateExit | number}}
                    </div>
                </td>

                <!-- Primary Cohorts -->
                <td *ngIf="visibleColumns.cohort && primaryCohortsExpanded">
                    <ng-container *ngFor="let cm of jobMaterial.Material.CohortMaterial | orderBy:'Cohort.CohortName'; let last = last">
                        <ng-container *ngFor="let jc of jobMaterial.Job.JobCohort | orderBy:'Cohort.CohortName'; let last = last">
                            <div *ngIf="cm.C_Cohort_key == jc.C_Cohort_key && cm.Cohort as cohort"
                                 class="cohort-badge"
                                 [class.mt-1]="visibleColumns.nickname"
                                 [ngStyle]="{ backgroundColor: cohort.BackgroundColor, color: cohort.ForegroundColor }">
                                {{cohort.CohortName}}
                            </div>
                        </ng-container>
                    </ng-container>
                </td>

                <!-- All Cohorts -->
                <td *ngIf="visibleColumns.cohort && !primaryCohortsExpanded">
                    <ng-container *ngFor="let cm of jobMaterial.Material.CohortMaterial | orderBy:'Cohort.CohortName'; let last = last">
                        <div *ngIf="cm.Cohort as cohort"
                             class="cohort-badge"
                             [class.mt-1]="visibleColumns.nickname"
                             [ngStyle]="{ backgroundColor: cohort.BackgroundColor, color: cohort.ForegroundColor }">
                            {{cohort.CohortName}}
                        </div>
                    </ng-container>
                </td>

                <!-- Sequence -->
                <td *ngIf="visibleColumns.sequence">
                    <div [class.mt-1]="visibleColumns.nickname">
                        {{jobMaterial.Sequence}}
                    </div>
                </td>
            </ng-container>
        </tr>
    </tbody>
</table>

<pagination-controls (pageChange)="changePage($event)"
                     (pageBoundsCorrection)="changePage($event)"
                     [autoHide]="true"
                     class="ngx-table-paginator"
                     id="animals-individual-pagination"></pagination-controls>
